/**
 * Badge en el ícono de la PWA instalada (Badging API). Sin soporte (Safari sin
 * instalar, Firefox) no hace nada. El service worker (push.js) también lo pone al
 * llegar un push; aquí la página lo ajusta cuando ya se está viendo.
 */
export function setAppBadge(count) {
  try {
    if (!("setAppBadge" in navigator)) return;
    if (count > 0) navigator.setAppBadge(count).catch(() => undefined);
    else navigator.clearAppBadge().catch(() => undefined);
  } catch { /* noop */ }
}

export function clearAppBadge() {
  setAppBadge(0);
}

/** Limpia el badge al abrir/volver a la app: lo que había pendiente ya se está viendo. */
export function clearAppBadgeOnFocus() {
  clearAppBadge();
  const onVisible = () => { if (document.visibilityState === "visible") clearAppBadge(); };
  document.addEventListener("visibilitychange", onVisible);
  return () => document.removeEventListener("visibilitychange", onVisible);
}
